<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/i8NKox/tc-custom/9783989733824.jpg?1731055223276" alt="This image is the cover for the book Making Good For Muley & Shepherds For Science, CLASSICS TO GO"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Making Good For Muley & Shepherds For Science, CLASSICS TO GO
      </h1>
      <p class="bookDescription body article font2">
        <p>In "Making Good For Muley &amp; Shepherds For Science," W. C. Tuttle masterfully intertwines the rugged charm of the Old West with the relentless pursuit of scientific discovery. Muley, a determined cowboy, and a group of eccentric shepherds find themselves embroiled in a high-stakes adventure that tests their grit and ingenuity. As they navigate treacherous landscapes and confront formidable adversaries, their journey becomes a testament to the power of resilience and the unyielding human spirit. Tuttle's vivid storytelling captures the essence of camaraderie and the timeless struggle between tradition and progress. This gripping tale resonates with contemporary society, highlighting the enduring relevance of perseverance, innovation, and the bonds that unite us in the face of adversity.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        W. C. Tuttle
      </h2>
      
      <p class="authorDescription body article">W. C. Tuttle, born on November 11, 1883, in Montana, was a prolific American writer best known for his contributions to the Western genre. Tuttle's upbringing in the rugged landscapes of the American West profoundly influenced his storytelling, imbuing his works with authenticity and a keen sense of place. His career spanned several decades, during which he penned over a thousand stories, novels, and screenplays, becoming a staple in pulp magazines like "Adventure" and "Argosy."<br>Tuttle's most famous creation, the character Hashknife Hartley, a cowboy detective, became a beloved figure in Western fiction, blending elements of mystery and adventure. This innovative fusion of genres set Tuttle apart from his contemporaries and showcased his versatility as a writer. His works often explored themes of justice, morality, and the complexities of frontier life, resonating with readers who craved both excitement and depth.<br>Despite his popularity, Tuttle's career was not without controversy. He faced criticism for perpetuating certain stereotypes of the American West, yet he also received praise for his vivid characterizations and gripping narratives. His influence extended to contemporary writers who admired his ability to craft compelling, fast-paced stories that captured the spirit of the Old West.<br>W. C. Tuttle's legacy endures as a testament to his storytelling prowess and his significant impact on the Western genre. His works continue to be celebrated for their entertainment value and their contribution to the mythos of the American frontier, ensuring his place in the annals of literary history.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?01ef7dbb